/**
 * Shared icon and title constants for member verification (MVR) indicators.
 */

/** Icons and titles for a completed member verification, pass or fail. */
export const MVR_VERIFICATION_ICONS = {
	customSuccessIcon: "check-circle",
	customErrorIcon: "times-circle",
	successTitle: "Member verified successfully",
	errorTitle: "Member verification failed",
};

/** The outcome of the member verifications that a batch holds. */
export type MvrOutcome = "NONE" | "VERIFIED" | "PENDING" | "FAILED";

/** The icon and the title for a member verification that waits for an outcome. */
export const MVR_PENDING_ICON = {
	customWarningIcon: "exclamation-triangle",
	warningTitle: "Member verification pending",
};

/**
 * Maps the outcome of a batch to the flags that GridErrorWarningRenderer reads.
 * A batch shows the worst outcome that it holds, so only one flag is ever true.
 *
 * @param outcome the outcome that the server sent for the batch
 */
export function mvrOutcomeIconProps(outcome: MvrOutcome) {
	return {
		...MVR_VERIFICATION_ICONS,
		...MVR_PENDING_ICON,
		withSuccess: outcome === "VERIFIED",
		withWarning: outcome === "PENDING",
		withError: outcome === "FAILED",
	};
}

/**
 * Builds the tooltip title for the status column of the contributions employee grid.
 * A row can carry a member verification concern, a validation warning, or both.
 *
 * @param outcome the member verification outcome for the row
 * @param withWarning true when the row has a contribution validation warning
 */
export function mvrWarningTitle(
	outcome: MvrOutcome,
	withWarning: boolean
): string {
	const withMvorWarning = outcome === "PENDING" || outcome === "FAILED";
	if (withMvorWarning && withWarning) {
		return "MVR & Warning";
	}
	if (withMvorWarning) {
		return "MVR Warning";
	}
	return "Warning";
}
